import React from 'react';
import { ReactComponent as LimitReachedIcon } from 'Assets/svg/limit-reached-icon.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import * as CONSTANTS from 'Utils/constants';

const LimitReachedPopUp = ({ open, onClose, data, history }) => {
  return (
    open && (
      <>
        <div className="common-popup">
          <div className="popup-wrap limit-popup-wrap">
            <LimitReachedIcon />
            <CloseIcon onClick={onClose} className="popup-close-icon" />
            <span className="limit-header">Limit Reached</span>
            <p className="limit-text">
              {`You have reached the maximum saved searches allowed per account (${data.maxSaveSearchCount ||
                100}). Please delete other saved
              searches to proceed.`}
            </p>
            <button
              type="button"
              onClick={() => {
                history.push(
                  CONSTANTS.PAGE_PATH_MAP.CONTACT_SEARCH_SAVED_SEARCHES,
                );
                onClose();
              }}
            >
              Manage saved searches
            </button>
          </div>
        </div>
        <div
          className="common-popup-mask common-back-ground"
          onClick={onClose}
        />
      </>
    )
  );
};
export default LimitReachedPopUp;
